import { Flex, Title, Button } from '@mantine/core';
import { MedplumLink } from '@medplum/react';
import { MemberTable } from '../MembersTable';

export function ClientsPage(): JSX.Element {
  return (
    <>
      
      <Flex
        justify="space-between"
        align="flex-center"
      >
        <Title>Clients</Title>
        
        <MedplumLink to={`/client/new`} sx={{
          marginBottom:'20px'
        }}>
          <Button 
            type="button"
            onClick={()=>{
            }}  
          >
            + Create client
          </Button>
        </MedplumLink>
      </Flex>
      <MemberTable resourceType="ClientApplication" fields={['name', '_lastUpdated', 'action']} />
    </>
  );
}
